
/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1(3|4|5|6|7|8|9)\d{9}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}